import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Universe } from 'app/shared/models/class/universe/universe';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UniverseService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getUniverse(): Observable<Universe[]> {
    return this.http.get<Universe[]>(`${environment.apiUrl}/universe`);
  }

}
